import React, {useContext} from "react";
import {css} from "emotion";
import CheckoutForm from "./CheckoutForm";
import CheckoutPlan from "./CheckoutPlan";
import {boxStyles} from "../../styles/theme";
import PurchaseOverview from "./PurchaseOverview";
import {GlobalContext} from "../../context/GlobalState";
import ConfirmOrderButton from "./ConfirmOrderButton";
import getPlanName from "../../utils/getPlanName";

const CheckoutBody = () => {
  const {currentWorkspace} = useContext(GlobalContext);
  const {hasBillingCard} = currentWorkspace;
  const name = getPlanName(currentWorkspace);

  return (
    <div className={container}>
      <CheckoutPlan showDiscount={name !== "free"} currentPlan={currentWorkspace.currentPlan}/>
      {name !== "free" && <PurchaseOverview/>}
      {hasBillingCard ? <ConfirmOrderButton/> : <CheckoutForm/>}
    </div>
  );
};

export default CheckoutBody;

const container = css`
  padding: ${boxStyles.standardPadding};

  @media screen and (min-width: ${boxStyles.desktopBreak}) {
    padding: ${boxStyles.standardPadding} 0;
    max-width: 450px;
    margin: auto;
  }
`;
